import { disableVanillaSubmit, enableVanillaSubmit, setCookie } from '../../../layout-common/js/parts/utils';

/**
 * Odeslání dat do GA po kliknutí na tlačítko
 * @param {HTMLElement} element tlačítko
 * @param {string} event
 */
const sendDataToGa = function (element, event) {
	let offerId = element.getAttribute('data-offerid');
	let companyId = element.getAttribute('data-companyid');
	let buttonLocation = 'default';
	try {
		buttonLocation = element.dataset.loc;
	} catch (e) {
		// do not care
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: event,
		offerId: offerId,
		companyId: companyId,
		eventCategory: 'offerReply',
		eventAction: 'all',
		buttonLocation: buttonLocation
	});
};

/**
 * Kontrola na počet souborů, jak vybraných v upload komponentě, tak v checkboxech
 * @param {HTMLFormElement} formEl
 * @returns {int} vrací počet zbývajících souborů
 */
const validateMaxAttachedFiles = function (formEl) {
	// Checkboxy s přílohami
	const attachmentsList = formEl.querySelectorAll('input[name*="attachments"]');
	// Upload políčka - nově používáme jeden multipload
	const fileUploadInput = formEl.querySelector('.jp-upload input[name*="fileAttachments"]');

	const checkedFilesCount = Array.from(attachmentsList).filter((input) => input.checked).length;
	const selectedFilesCount = fileUploadInput?.files.length;
	const maxAttachedFiles = parseInt(formEl.dataset.maxAttachedFiles);

	const disableUnchecked = checkedFilesCount + selectedFilesCount >= maxAttachedFiles;
	for (const input of attachmentsList) {
		if (!input.checked) {
			input.disabled = disableUnchecked;
		}
	}

	// Nastavujeme maxFile, aby upload věděl, kolik lze ještě přidat souborů
	// neodečítáme `selectedFilesCount`, protože upload o svých souborech ví
	fileUploadInput.dataset.maxFiles = maxAttachedFiles - checkedFilesCount;

	document.querySelector('.attached-files-validation-error')?.classList.toggle('hidden', !disableUnchecked);

	return maxAttachedFiles - checkedFilesCount - selectedFilesCount;
};

/**
 * Kontrola jestli je možné ještě přidat nějaký soubor, pokud ne, vypíšeme nette error
 * @param {Event} e
 * @param {HTMLFormElement} formEl
 */
const showMaxAttachedFilesErrorIfOccured = function (e, formEl) {
	if (validateMaxAttachedFiles(formEl) <= 0) {
		Nette.showFormErrors(formEl, [
			{
				element: 'attachments[]',
				message: `Můžete připojit maximálně ${parseInt(formEl.dataset.maxAttachedFiles)} příloh.`
			}
		]);

		e?.stopPropagation();
	}
};

/**
 * Zobrazení zprávy v reply formu (načítám formulář, odesílám odpověď apod.)
 * @param {string} message
 */
const setReplyMessage = function (message) {
	document.getElementById('js-offer-reply-message').classList.remove('d-none');
	document.getElementById('js-offer-reply-message-content').textContent = message;
	document.getElementById('js-offer-reply-message').scrollIntoView({
		behavior: 'smooth', // plynulé posunutí
		block: 'start' // zarovná prvek na začátek viewportu (nahoru)
	});
};

/**
 * Skrytí zprávy v replyformu
 */
const closeReplyMessage = function () {
	document.getElementById('js-offer-reply-message').classList.add('d-none');
};

/**
 * Načtení reply formu po kliknutí na tlačítko
 * @param {HTMLElement} element odkaz pro otevření
 * @param replyEl
 * @param e
 * @returns
 */
const openReply = function (element, replyEl, e) {
	let opened = false;

	if (element.getAttribute('data-is-external')) {
		sendDataToGa(element, 'externalreplyclick');

		$.get(replyEl.getAttribute('data-track-external-link'), function () {
			scroll(0, 0);
		});

		return;
	} else {
		e.preventDefault(); // Zabrání přechodu na #
	}

	sendDataToGa(element, 'replyclick');

	// Odebeme float-button-container - není potřeba
	element.closest('.float-button-cont')?.remove();

	setReplyMessage('Načítám odpovědní formulář...');

	$.nette.ajax({
		url: replyEl.dataset.url,
		success: function (payload) {
			if (payload.snippets) {
				opened = true;
			}

			const snippets = $.nette.ext('snippets');
			snippets.after(function ($el) {
				$el.get(0)
					.querySelectorAll('form')
					.forEach(function (formEl) {
						window.Nette.initForm(formEl);
						initForm(formEl, replyEl);
						let reply = document.getElementById('odpovedet');
						if (reply !== null) {
							reply.scrollIntoView({
								behavior: 'smooth', // plynulé posunutí
								block: 'start' // zarovná prvek na začátek viewportu (nahoru)
							});
							reply.classList.remove('mpsv-cont-bottom');
						}
					});
			});

			closeReplyMessage();
		},
		complete: function () {
			if (!opened) {
				setReplyMessage(
					'Odpovědní formulář se nepodařilo načíst.' + ' Zkuste opakovat akci nebo obnovit stránku.'
				);

				setTimeout(closeReplyMessage, 4500);
			}
		}
	});
};

/**
 * Inicializace JS pro reply form, obsluha pro kontrolu duplicit a následné odeslání
 */
const initForm = function (formEl, replyEl) {
	if (formEl.id !== 'frm-replyForm') {
		///pouze pro odpovedni formular (jmeno, email, prilohy,...)
		///nespoustet nad jinym formularem (napr. individualni odpovedni formular)
		return;
	}

	formEl.addEventListener('submit', function (e) {
		let offerId = formEl.dataset.checkOfferId;
		let checkDuplicityUrl = formEl.dataset.checkUrl;
		let email = replyEl.querySelector('#frm-replyForm-email')?.value;
		let submitBtn = replyEl.querySelector('form').querySelector('[type=submit]');

		if (!checkDuplicityUrl) {
			return;
		}

		let submitDisableTimeout = disableVanillaSubmit(submitBtn);

		if ((!Nette.formErrors.length || Nette.formErrors.length === 0) && offerId && checkDuplicityUrl.length) {
			$.nette.ajax({
				type: 'POST',
				url: checkDuplicityUrl,
				data: {
					offerId: offerId,
					email: email
				},
				success: function (data) {
					// Pokud už jsme jednou odesílali odpověď,
					// příjde ze serveru info o duplicitě - otevíráme potvrzovací modal
					if (data.isDuplicity) {
						const replyDuplicityModalEl = document.getElementById('reply-duplicity-popup');
						if (replyDuplicityModalEl instanceof HTMLElement) {
							const replyDuplicityModal = window.Modal.getOrCreateInstance(replyDuplicityModalEl);
							replyDuplicityModal.show();
							let datOfLastReplyEl = replyDuplicityModalEl.querySelector('span.dateOfLastReply');

							if (datOfLastReplyEl instanceof HTMLElement)
								datOfLastReplyEl.innerText = data.duplicityDate;
						}

						enableVanillaSubmit(submitBtn, submitDisableTimeout);
					} else {
						replyEl.querySelector('form').submit();
					}

					// Potvrzení, že chceme odeslat odpověď znovu
					document.querySelector('.yesSendReplyAndContinue').addEventListener('click', function (e) {
						disableVanillaSubmit(e.currentTarget);
						replyEl.querySelector('form').submit();
					});
				}
			});
		}

		e.preventDefault();
		return false;
	});

	// Obsluha po kliknutí na checkbox s přílohou
	for (const el of formEl.querySelectorAll('input[name*=attachments]')) {
		el.addEventListener('change', () => validateMaxAttachedFiles(formEl));
	}

	// Obsluha změny ve file inputu
	for (const el of formEl.querySelectorAll('.jp-upload input[name*=fileAttachments]')) {
		el.addEventListener('change', () => validateMaxAttachedFiles(formEl));
	}

	// Obsluha kliknutí na label okolo checkboxu s přílohou
	for (const el of formEl.querySelectorAll('.attachments label')) {
		el.addEventListener('click', (e) => {
			// pokud máme checkbox disabled, tak bude checked === false,
			// tj. už nelze vybrat další soubor a proto zobrazíme uživateli hlášku
			if (!el.querySelector('input')?.checked) {
				showMaxAttachedFilesErrorIfOccured(e, formEl);
			}
		});
	}

	for (const el of document.querySelectorAll('.jp-upload')) {
		el.addEventListener('click', (e) => {
			// pokud máme input maxFiles === 0, nemůžeme již přidat další soubor a zobrazíme hlášku
			if (parseInt(el.querySelector('input')?.dataset.maxFiles) === 0) {
				e.preventDefault();
				e.stopPropagation();

				showMaxAttachedFilesErrorIfOccured(e, formEl);
			}
		});
	}

	validateMaxAttachedFiles(formEl);
};

export default function () {
	const replyEl = document.getElementById('js-offer-reply');
	if (!replyEl) {
		return;
	}

	const replyFormEl = replyEl.querySelector('form');

	if (replyFormEl) {
		// page already contains form (for example in case of errors)
		initForm(replyFormEl, replyEl);
	}

	document.querySelectorAll('.js-offer-do-reply').forEach(function (el) {
		el.addEventListener('click', function (e) {
			if (!e.defaultPrevented) { // Zamezení vícenásobného otevření reply okna (na float buttonu máme data-prevent-multiple-click)
				openReply(el, replyEl, e);
			}
		});
	});

	const hash = window.location.hash;
	if (hash === '#openReply') {
		document.querySelector('.js-offer-do-reply')?.dispatchEvent(new Event('click'));
	}

	// Po odeslání reply, se podívá, zda má referer, a pokud ano, po timeoutu se na něj přesměruje
	function redirectFinishReply(isOpenReplyPopUp) {
		let refererForRedirect = document.getElementById('referer-for-redirect');
		if (refererForRedirect) {
			let url = refererForRedirect.getAttribute('data-referer');
			let pid = refererForRedirect.getAttribute('data-pid');
			if (url !== 'no-referer' && url.length > 0 && !isOpenReplyPopUp) {
				setCookie('showmessage', '1', 60); // 1 min
				setTimeout(function () {
					window.location.href = url + '#' + pid;
				}, 1500);
				return true;
			} else {
				return false;
			}
		}
	}

	let isOpenReplyPopUp = false;

	// Vrátil se nám reply-popup modal
	const replyPopUpModalEl = document.getElementById('reply-popup');
	if (replyPopUpModalEl instanceof Element) {
		isOpenReplyPopUp = true;
	}

	redirectFinishReply(isOpenReplyPopUp);

	// Po zavření reply modalu dojde o redirectu nebo obnovení stránky
	replyPopUpModalEl?.addEventListener('hide.bs.modal', (e) => {
		isOpenReplyPopUp = false;
		let isRedirect = redirectFinishReply();
		if (!isRedirect) {
			let submitBtn = document.querySelector('#frm-replyForm .submit input');
			if (submitBtn !== null) {
				disableVanillaSubmit(submitBtn);
			}

			setTimeout(function () {
				window.location.reload();
			}, 2000);
		}
	});
}
